module.exports = __webpack_public_path__ + "static/media/Device Marketplace App Overview - GBR Network - 08-10-2024 N .884cb109.gif";